<cdx-grid [options]="customOptions">
  <div navbar>
    <div class="edit-envelope__navbar">
      <button style="z-index: 1;" class="cdx-button cdx-button--icon cdx-button--lg" (click)="showConfirmWindow()">
        <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','arrow-left']"></fa-icon>
      </button>
      <h3>{{("envelopeEdit.navbarTitle") | translate}}</h3>
    </div>
  </div>

  <div content>
    <div class="mt-1">
      <cdx-tabset (onSelect)="tabSelect($event)" [childTemplate]="tabTemplate" [customSlider]="true"
      [dropdown]="dropdown">
      <cdx-tab [customView]="tabInformation">
      </cdx-tab>
      <!-- <cdx-tab [customView]="tabAuthorizers"></cdx-tab> -->
      <cdx-tab [customView]="tabSignatories">
      </cdx-tab>
    </cdx-tabset>
    </div>

    <ng-template #tabTemplate let-tab="context">
      {{tab.title | translate | titlecase }}
      <div class="{{tab.badgeClass}}">{{ tab.badgeValue}}</div>
    </ng-template>

    <div class="edit-envelope__container">
      <app-edit-envelope-information *ngIf="tabSelected === envelopeEditTabs.Information">
      </app-edit-envelope-information>
      <!-- <app-edit-envelope-authorizers *ngIf="tabSelected === 1"></app-edit-envelope-authorizers> -->
      <app-edit-envelope-signatories *ngIf="tabSelected === envelopeEditTabs.Signatory"></app-edit-envelope-signatories>
    </div>

    <footer class="footer fixed-bottom bg-gray pt-3">
      <div class="container-fluid">
        <div class="col-md-3 footer__buttons d-flex justify-content-center justify-content-md-end float-right">
          <button class="cdx-button cdx-button--primary cdx-button--outline ml-0"
            (click)="canShowConfirmEditWindow(confirmEditModal)" [disabled]="disabledButtonCompleteEditing()">
            <span class="cdx-button__text">{{ 'envelope-edit.footer.completeEditing' | translate | uppercase}}</span>
          </button>
        </div>
      </div>
    </footer>
  </div>
</cdx-grid>

<ng-template #confirmBackModal>
  <app-confirm-modal [HeaderText]="'envelope-edit.backModal.headerText'"
    [QuestionText]="'envelope-edit.backModal.questionText'" [MessageText]="'envelope-edit.backModal.messageText'"
    (closeModalClick)="confirmModalClose()" (confirmModalClick)="confirmModalYesClick()" [ButtonConfirmText]="'yes'"
    [ButtonCancelText]="'no'" [IsApprovalConfirm]=false>
  </app-confirm-modal>
</ng-template>

<ng-template #confirmEditModal>
  <app-confirm-modal [HeaderText]="'envelope-edit.editModal.headerText'"
    [QuestionText]="'envelope-edit.editModal.questionText'" [MessageText]="'envelope-edit.editModal.messageText'"
    (closeModalClick)="confirmModalClose()" (confirmModalClick)="confirmEditModalCompleteClick()"
    [ButtonConfirmText]="'envelope-edit.editModal.complete'" [ButtonCancelText]="'envelope-edit.editModal.back'"
    [IsApprovalConfirm]=false>
  </app-confirm-modal>
</ng-template>
